
import { Button } from 'vant'
import { ref } from '@vue/reactivity'
import { useRoute } from 'vue-router'
import { useCommonAnswerCountEffect } from '@/effects/sdwsEffect.js'

import { getCountByShare } from '@/api/sdws'
import { useStore } from 'vuex'
export default {
  components: {
    Button
  },
  emits: ['close'],
  setup(props, ctx) {
    const showShareTips = ref(false)
    const store = useStore()
    const route = useRoute()

    const { fetchCountData } = useCommonAnswerCountEffect()

    const { handleShareClick } = userShareCountEffect()
    const chandleShareClick = () => {
      let mockShare = false
      showShareTips.value = true
      if (window.wx) {
        console.log('进来了')
        window.wx.onMenuShareAppMessage({
          title: store.getters.getShareInfo?.shareTitle || document.title,
          desc: store.getters.getShareInfo?.shareDesc,
          imgUrl: store.getters.getShareInfo?.shareIcon,
          link: `https://qlwhdh.iqilu.com/h5/#/custom/sdws/?questionActiveKey=${route.query.questionActiveKey}&orgid=413`,
          success: function () {
            console.log('回调')
            mockShare = true
            showShareTips.value = false
            ctx.emit('close')
            fetchCountData()
            // 清空选项
            handleShareClick()
          }
        })
        window.wx.onMenuShareTimeline({
          title: store.getters.getShareInfo?.shareTitle || document.title,
          desc: store.getters.getShareInfo?.shareDesc,
          imgUrl: store.getters.getShareInfo?.shareIcon,
          link: `https://qlwhdh.iqilu.com/h5/#/custom/sdws/?questionActiveKey=${route.query.questionActiveKey}&orgid=413`,
          success: function () {
            console.log('回调')
            showShareTips.value = false
            mockShare = true
            ctx.emit('close')
            fetchCountData()
            // 清空选项
            handleShareClick()
          }
        })
      }
      setTimeout(() => {
        if (!mockShare) {
          showShareTips.value = false
          ctx.emit('close')
          fetchCountData()
          // 清空选项
          handleShareClick()
        }
      }, 4000)
    }

    return {
      chandleShareClick,
      showShareTips,
      handleShareClick
    }
  }
}
// 分享获得回答次数
const userShareCountEffect = () => {
  const route = useRoute()
  const store = useStore()

  const showShareTips = ref(false)

  const handleShareClick = async () => {
    const res = await getCountByShare({
      questionActiveKey: route.query.questionActiveKey,
      token: store.getters.getToken
    })

    console.log('res', res)
  }

  return {
    showShareTips,
    handleShareClick
  }
}
